import state from './state.js'
import getters from './getters.js'
import actions from './actions.js'

const storeOptions = {
  state,
  actions,
  getters,
  persist: {
    storage: piniaPluginPersistedstate.sessionStorage()
  }
}

export const useUtmsStore = defineStore('utms', storeOptions)
